import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useFamilySession } from "../hooks/use-family-session";
import { ErrorPanel } from "./feedback/ErrorPanel";
import { RouteLoading } from "./RouteLoading";

export function RequireFamily() {
  const session = useFamilySession();
  const location = useLocation();

  if (session.isPending) return <RouteLoading />;
  if (session.isError) {
    return (
      <ErrorPanel
        title="家庭入口暂时未接上"
        message={session.error.message}
        actionLabel="重新连接"
        onAction={() => void session.refetch()}
        fullPage
      />
    );
  }
  if (!session.data) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  return <Outlet />;
}
